import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';

const RouteHandler = () => {
    const { isAuthenticated, auth_info } = useSelector((state) => state.auth);
    const location = useLocation();

    if (isAuthenticated && (location.pathname === '/' || location.pathname === '/login')) {
        return <Navigate to={auth_info?.route_path } replace />;
    }

    return null;
};

export default RouteHandler;